<template>
  <nav class="nav-container">
    <div class="inner">
      <span class="brand">
        <!-- <img src="@/assets/image/brand.png" /> -->
      </span>
      <ul class="menus" ref="menus">
        <li>
          <a class="link-item" href="https://massnet.org">{{
            $t("home.nav.home")
          }}</a>
        </li>
        <li>
          <router-link to="/mine">
            <a class="link-item">{{ $t("home.nav.mine") }}</a>
          </router-link>
        </li>
        <li>
          <router-link to="/trade">
            <a class="link-item">{{ $t("home.nav.trade") }}</a>
          </router-link>
        </li>
        <li class="d-xs-none">
          <router-link to="/activation">
            <a class="link-item">{{ $t("home.nav.activation") }}</a>
          </router-link>
        </li>
        <li>
          <a class="link-item">
            <span
              class="languageIcon"
              :class="{ active: $i18n.locale === 'zh-CN' }"
              @click="changeLanguage('zh-CN')"
              >CN</span
            >/<span
              class="languageIcon"
              :class="{ active: $i18n.locale === 'en-US' }"
              @click="changeLanguage('en-US')"
              >EN</span
            >
          </a>
        </li>
        <li>
          <a class="link-item"
            ><span class="logout-btn" @click="toLogout">{{
              $t("home.nav.logout")
            }}</span></a
          >
        </li>
        <div class="mask" @click="hideMenu"></div>
      </ul>
      <div class="menu-icon" @click="showMenu">
        <img src="@/assets/image/menu.svg" />
      </div>
    </div>
  </nav>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "wheader",
  watch: {
    $route() {
      this.docTitle();
      if(this.isMobile()){
      this.$refs.menus.style.display = "none";
      }
    },
  },
  methods: {
    ...mapActions("user", ["logout"]),
    showMenu() {
      this.$refs.menus.style.display = "block";
    },
    isMobile() {
      let info = navigator.userAgent;
      let agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPod",
        "iPad",
      ];
      for (let i = 0; i < agents.length; i++) {
        if (info.indexOf(agents[i]) >= 0) return true;
      }
      return false;
    },
    hideMenu() {
      this.$refs.menus.style.display = "none";
    },
    toLogout() {
      this.logout();
      window.location.reload();
    },
    changeLanguage(lang) {
      localStorage.setItem("MASSWALLETLOCALE", lang);
      this.$i18n.locale = lang;
      document.documentElement.lang = lang;
    },
    docTitle() {
      const { name } = this.$route;
      switch (name) {
        case "home":
          document.title = this.$t("home.nav.mine");
          break;
        case "trade":
          document.title = this.$t("home.nav.trade");
          break;

        case "mine":
          document.title = this.$t("home.nav.mine");
          break;

        case "activation":
          document.title = this.$t("home.nav.activation");
          break;

        default:
          break;
      }
    },
  },
  mounted() {
    document.documentElement.lang =
      localStorage.getItem("MASSWALLETLOCALE") || "zh-CN";

    this.docTitle();
  },
};
</script>
<style lang="scss" scoped>
.nav-container {
  z-index: 15;
  position: relative;
  .inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1170px;
    max-width: 96%;
    margin: auto;
    .brand {
      vertical-align: middle;
      img {
        width: 200px;
      }
    }
  }
}
.menus {
  display: inline-flex;
  .link-item {
    cursor: pointer;
    display: inline-block;
    padding: 28px 20px;
    font-size: 15px;
    color: rgba(255, 255, 255, 0.6);
    line-height: 16px;
    text-decoration: none;
    &.active {
      color: #fff;
    }
  }
  .router-link-exact-active .link-item {
    color: #fff;
  }
  .logout-btn {
    padding: 10px 50px;
    border-radius: 22px;
    border: 1px solid #ffffff;
  }
}
.menu-icon {
  display: none;
  img {
    width: 30px;
  }
}
@media screen and (max-width: 768px) {
  .nav-container .inner .brand {
    img {
      width: 120px;
    }
  }
  .d-xs-none {
    display: none;
  }
  .menu-icon {
    display: inline-block;
    padding: 10px 0;
  }
  .languageIcon {
    color: rgba(6, 6, 6, 0.2) !important;
  }
  .languageIcon.active {
    color: #080807 !important;
  }
  .menus {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: none;
    z-index: 9;
    text-align: center;
    li {
      background: #ffffff;
      .link-item {
        font-weight: 400;
        color: #050505;
      }
      .router-link-exact-active .link-item {
        color: #dc472a;
      }
    }
    .logout-btn {
      border: none;
      color: #dc472a;
      text-decoration: underline;
    }
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(25, 31, 47, 0.8);
      z-index: -1;
    }
  }
}
.languageIcon.active {
  color: #fff;
}
</style>
